import { v4 as uuidv4 } from 'uuid'
import { ComplianceFramework } from '@trustero/trustero-api-web/lib/audit/framework_pb'
import {
  GridColumnSortFrameworks,
  GridColumnSortType,
} from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'
import { RequirementDraft } from './frameworks.types'

export const createEmptyRequirementDraft = (): RequirementDraft => ({
  tempId: uuidv4(),
  name: '',
  category: '',
  groupDescription: '',
  description: '',
  controlIds: [],
})

const getFrameworkSortValue = (
  framework: ComplianceFramework,
  col: GridColumnSortFrameworks,
  counts: {
    requirementsByFrameworkId: Record<string, number>
    controlsByFrameworkId: Record<string, number>
    auditsByFrameworkId: Record<string, number>
  },
): string | number => {
  const id = framework.getId()
  switch (col) {
    case GridColumnSortFrameworks.NAME:
      return framework.getName().toLowerCase()
    case GridColumnSortFrameworks.DESCRIPTION:
      return framework.getDescription().toLowerCase()
    case GridColumnSortFrameworks.REQUIREMENTS:
      return counts.requirementsByFrameworkId[id] ?? 0
    case GridColumnSortFrameworks.CONTROLS:
      return counts.controlsByFrameworkId[id] ?? 0
    case GridColumnSortFrameworks.AUDITS:
      return counts.auditsByFrameworkId[id] ?? 0
    default:
      return ''
  }
}

export const sortFrameworks = (
  frameworks: ComplianceFramework[],
  sortCol: GridColumnSortFrameworks,
  sortType: GridColumnSortType,
  counts: {
    requirementsByFrameworkId: Record<string, number>
    controlsByFrameworkId: Record<string, number>
    auditsByFrameworkId: Record<string, number>
  },
): ComplianceFramework[] => {
  const sorted = [...frameworks].sort((a, b) => {
    const av = getFrameworkSortValue(a, sortCol, counts)
    const bv = getFrameworkSortValue(b, sortCol, counts)
    if (av < bv) return -1
    if (av > bv) return 1
    return 0
  })
  if (sortType === GridColumnSortType.DESCENDING) sorted.reverse()
  return sorted
}
